import { useState } from "react";
import EmployerOnboardingModal from "./EmployerOnboardingModal";
import { useHistory } from "react-router-dom";

export default function EmployerTips() {
    const [showModal, setShowModal] = useState(true);
    const history = useHistory();

    const handleModalClose = () => {
        setShowModal(false);
        history.push(`${process.env.PUBLIC_URL}/dashboard`);
    };

    const handleFinish = () => {
        setShowModal(false);
        history.push(`${process.env.PUBLIC_URL}/dashboard`);
    };

    return (
        <div className="container p-0">
            <EmployerOnboardingModal
                show={showModal}
                onHide={handleModalClose}
                onFinish={handleFinish}
            />
        </div>
    );
}
